
import Vue from 'vue'
import userManager from '@/user-manager'
import MainLayout from '@/components/MainLayout.vue'

export default Vue.extend({
	name: 'NonLoginChatRoom',
	components: {
		MainLayout
	},
	data() {
		return {
			loginDialog: true,
			mockChannels: [
				{ name: 'Namecard', lastMessage: 'Hi, I saw your profile on Namecard...', time: '10:30' },
			],
			mockMessages: [
				{ isMe: false, senderName: 'Namecard', content: 'Hi, I saw your profile on Namecard and I believe we could create great value together. Would you be interested in connecting?', time: '10:30' },
			]
		}
	},
	methods: {
		login() {
			localStorage.setItem('LOGIN_TO_PAGE', 'chat')
			if (this.$route.params.chatTargetUserId) {
				localStorage.setItem('TARGET_USER_ID', this.$route.params.chatTargetUserId)
			}
			userManager.signinRedirect()
		}
	}
})
